import "./Control.css";
import React from "react";
import second from "../../../../Assets/Images/q1.svg";
import controlImg1 from "../../../../Assets/Images/control1.png";
import controlImg2 from "../../../../Assets/Images/control2.png";
import controlImg3 from "../../../../Assets/Images/control3.png";
import controlImg4 from "../../../../Assets/Images/control4.png";
import controlImg5 from "../../../../Assets/Images/control5.png";
import controlImg6 from "../../../../Assets/Images/control6.png";
import sk1 from "../../../../Assets/Images/sk11.png";
import sk2 from "../../../../Assets/Images/022.png";
import sk3 from "../../../../Assets/Images/033.png";
import sk4 from "../../../../Assets/Images/044.png";
import sk5 from "../../../../Assets/Images/055.png";
import sk6 from "../../../../Assets/Images/066.png";

export default function Control() {
  return (
    <div className="control">
      <div className="container">
        <div className="control-top">
          <img src={second} alt="" />
          <p className="control-text">
            We carefully monitor each step in our processing, We strictly adhere
            to all quality & hygiene parameters just so you can rest assured
            about quality of your product .
          </p>
        </div>
        <ul className="control-list">
          <li className="control-item">
          <div className="control-num">02</div>

        <img src={sk1} alt="" className="control-thumb" />
 
            <hr className="control-lefthr" />

            <div className="control-circle">
              <img src={controlImg1} alt="controlImg" 
              className="control-img" />
            </div>
            <div className="control-info">
              <h4 className="control-subtitle">Procurement</h4>
              <p className="control-subtext">
                Only the best quality crop is selected & procured by our
                experienced team of experts.
              </p>
              <a href="#" className="control-link">
                learn more
              </a>
            </div>
          </li>
          <hr className="control-hr" />
          <li className="control-item control-item-even">
            <div className="control-info">
              <h4 className="control-subtitle">CO2 Fumigation</h4>
              <p className="control-subtext">
                Selected crops are subjected to CO2 fumigation to get rid of
                bacteria, pests or insect infestation if any.
              </p>
              <a href="#" className="control-link">
                learn more
              </a>
            </div>
            <div className="control-circle">
              <img src={controlImg2} alt="controlImg" className="control-img" />
            </div>

            <hr className="control-lefthr" />
            <div className="control-num">02</div>
            <img src={sk2} alt="" className="control-thumb" />

          </li>
          <hr className="control-hr" />
          <li className="control-item">
          <img src={sk3} alt="" className="control-thumb" />

            <div className="control-num">03</div>
            <hr className="control-lefthr" />

            <div className="control-circle">
              <img src={controlImg3} alt="controlImg" className="control-img" />
            </div>
            <div className="control-info">
              <h4 className="control-subtitle">Cleaning</h4>
              <p className="control-subtext">
                The crop is cleaned of any dirt and impurities with the help of
                most advanced cleaning machinery.
              </p>
              <a href="#" className="control-link">
                learn more
              </a>
            </div>
          </li>
          <hr className="control-hr" />
          <li className="control-item control-item-even">
            <div className="control-info">
              <h4 className="control-subtitle">Sorting & Grading</h4>
              <p className="control-subtext">
                Cleaned crop is then sorted and graded accordingly, with the
                help world class equipped technology
              </p>
              <a href="#" className="control-link">
                learn more
              </a>
            </div>
            <div className="control-circle">
              <img src={controlImg4} alt="controlImg" className="control-img" />
            </div>

            <hr className="control-lefthr" />
            <img src={sk4} alt="" className="control-thumb" />

            <div className="control-num">04</div>
          </li>
          <hr className="control-hr" />
          <li className="control-item">
          <img src={sk5} alt="" className="control-thumb" />

            <div className="control-num">05</div>
            <hr className="control-lefthr" />

            <div className="control-circle">
              <img src={controlImg5} alt="controlImg" className="control-img" />
            </div>
            <div className="control-info">
              <h4 className="control-subtitle">Packaging</h4>
              <p className="control-subtext">
                The product is packed at our packing stations adhering to
                international with automated as well as manual technology
              </p>
              <a href="#" className="control-link">
                learn more
              </a>
            </div>
          </li>
          <hr className="control-hr" />
          <li className="control-item control-item-even">
            <div className="control-info">
              <h4 className="control-subtitle">Storage</h4>
              <p className="control-subtext">
                The packed product is then stored in well ventilated & most
                hygienic warehouses and godowns which are checked & cleaned
                regualry
              </p>
              <a href="#" className="control-link">
                learn more
              </a>
            </div>
            <div className="control-circle">
              <img src={controlImg6} alt="controlImg" className="control-img" />
            </div>
            <hr className="control-lefthr" />
            <img src={sk6} alt="" className="control-thumb" />

            <div className="control-num">06</div>
          </li>
        </ul>
        <div className="control-bottom">
        ~ Our processing is not just processing,
 but also a Value addition ~
        </div>
      </div>
    </div>
  );
}
